import React from 'react';

/**
 * StartRow Component
 *
 * This component renders a table row indicating the start of a cycle or session.
 * It receives a 'data' object containing:
 * - 'text': a string to display on the left side of the row.
 *
 * The row spans the full width of the table using 'colSpan' and has a distinct background color.
 *
 * Props:
 * - data: { text: string }
 */
const StartRow = ({ data }) => {
  const { text } = data;

  return (
    <tr data-testid="start-row" className="bg-[#EFEFEF] whitespace-nowrap">
      <td className="px-4 py-1.5 text-black text-xs pl-[50px]" colSpan="100%">
        {text}
      </td>
    </tr>
  );
};

export default StartRow;
